import React from "react";

const PowerButton = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M15.502 16.876V4.48A2.49 2.49 0 0118 2a2.49 2.49 0 012.497 2.48v12.396A2.49 2.49 0 0118 19.356a2.49 2.49 0 01-2.498-2.48zM27.9 5.636a1.884 1.884 0 00-2.63.308 1.852 1.852 0 00.31 2.612c2.971 2.327 4.674 5.81 4.674 9.56 0 6.708-5.498 12.166-12.253 12.166-6.756 0-12.254-5.458-12.254-12.166 0-3.748 1.702-7.23 4.67-9.556a1.852 1.852 0 00.31-2.613 1.885 1.885 0 00-2.631-.308C4.222 8.674 2 13.222 2 18.116 2 26.877 9.178 34 18 34s16-7.126 16-15.884c0-4.896-2.224-9.444-6.1-12.48z"
          fill={fill}
      />
    </svg>
);

export default PowerButton;
